import { useState } from "react";
import { Link } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { motion } from "framer-motion";
import CustomCourseRequestPr from "../components/CustomCourseRequestPr";
import ModalWrapper from "./utils/ModalWrapper";
import { MonoButton } from "../kits"; 
import { usePlaceholder } from "../context/usePlaceholder";




function SearchOverlay({
  searchQuery,
  filteredCourses,
  onSearchChange,
  onClose,
  onResultClick,
}) {
  // Modal-State
  const [showModal, setShowModal] = useState(false);
  const { nameSinglePlaceholder } = usePlaceholder();

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, backdropFilter: "blur(0px)" }}
      animate={{ opacity: 1, y: 0, backdropFilter: "blur(8px)" }}
      exit={{ opacity: 0, y: -50, backdropFilter: "blur(0px)" }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      className="fixed inset-0 z-50 bg-white/80 overflow-y-auto overscroll-contain"
    >
      <div className="w-full min-h-[100dvh] flex flex-col justify-start items-center pt-20 text-black font-mono px-4">
        {/* Suchfeld */}
        <div className="w-full max-w-lg mb-6 relative">
          <input
            type="text"
            placeholder="wie kann ich Dir helfen?"
            value={searchQuery}
            onChange={onSearchChange}
            className="w-full border rounded-md py-2 px-4 focus:outline-none focus:ring-1 focus:ring-gray-900 text-xs text-center"
            autoFocus
          />
          <button
            onClick={onClose}
            className="absolute top-2 right-3 text-gray-600 hover:text-orange-500"
          >
            <FaTimes size={24} />
          </button>
        </div>

        {/* Ergebnisse */}
        <div className="w-full max-w-lg mb-10">
          {filteredCourses.length > 0 ? (
            filteredCourses.map((course, index) => (
              <motion.div
                key={course.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.05 * index, duration: 0.4 }}
              >
                <Link
                  to={`/course/${course.slug}`}
                  className="block px-4 py-2 hover:bg-pink-100 rounded-md"
                  onClick={() => {
                    onResultClick();
                    onClose();
                  }}
                >
                  {course.title}
                </Link>
              </motion.div>
            ))
          ) : (
            <div className="text-center font-mono flex flex-col items-center gap-4">
              <span>          <p className="text-gray-800 text-center text-xs sm:text-sm font-mono mb-6">
              Du stehst mittendrin in ein Projekt {nameSinglePlaceholder}?<br />
              Dann sag mir einfach, was dir fehlt. <br />
              Lass uns zusammen schauen, wie ich dir helfen kann!
            </p></span>
              <MonoButton
                onClick={() => setShowModal(true)}
                className="text-xs"
              >
               Anfrage stellen
              </MonoButton>
                   {showModal && (
  <ModalWrapper onClose={() => setShowModal(false)}>
    <CustomCourseRequestPr onClose={() => setShowModal(false)} />
  </ModalWrapper>
)}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default SearchOverlay;
